<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>Members Profile</h1>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#"> <i class="fa fa-dashboard"></i> Home </a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">Members</a>
        </li>
        <li class="breadcrumb-item active">Members Profile</li>
      </ol>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-xl-4 col-lg-5">
          <swap-leg></swap-leg>

          <div class="box bg-deathstar-dark">
            <div class="box-body box-profile">
              <img
                class="profile-user-img rounded img-fluid mx-auto d-block"
                :src="$store.getters.currentUser.avatar"
                alt="User profile picture"
              />

              <form>
                <div role="group" class="">
                  <div class="" bis_skin_checked="1">
                    <input
                      @change="changePicture"
                      type="file"
                      ref="picture"
                      required="required"
                      aria-required="true"
                      class="d-none"
                      accept="image/x-png,image/gif,image/jpeg"
                    />
                  </div>
                </div>

                <button
                  @click="$refs.picture.click()"
                  type="button"
                  class="btn btn-primary py-1 mx-auto text-center d-flex align-items-center"
                  :disabled="loading"
                >
                  <template v-if="!loading">
                    <i class="fa fa-camera pr-2"></i>
                    Change Profile Picture
                  </template>
                  <template v-else
                    >Loading <i class="fa fa-spinner fa-spin"></i
                  ></template>
                </button>
              </form>

              <h2 class="profile-username text-center mb-0 mt-4 text-uppercase">
                {{ this.$store.getters.currentUser.username }}
              </h2>

              <h4 class="text-center mt-0">
                <i class="fa fa-envelope-o mr-10"></i>
                {{ $store.getters.currentUser.email }}
              </h4>

              <div class="row">
                <div class="col-12">
                  <div
                    class="media-list media-list-hover media-list-divided w-p100 mt-30"
                  >
                    <router-link
                      :to="{ name: 'Network' }"
                      tag="h4"
                      class="media media-single p-15 pointer-cursor"
                    >
                      <i class="fa fa-arrow-circle-o-right mr-10"></i>
                      <span class="title">My Network</span>
                    </router-link>
                    <router-link
                      :to="{ name: 'Reports' }"
                      tag="h4"
                      class="media media-single p-15 pointer-cursor"
                    >
                      <i class="fa fa-arrow-circle-o-right mr-10"></i>
                      <span class="title">Reports</span>
                    </router-link>
                    <router-link
                      :to="{ name: 'Balance' }"
                      tag="h4"
                      class="media media-single p-15 pointer-cursor"
                    >
                      <i class="fa fa-arrow-circle-o-right mr-10"></i>
                      <span class="title">My Balance</span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-8 col-lg-7">
          <form action @submit.prevent="updateUser">
            <div class="box box-solid bg-black">
              <div class="box-header with-border">
                <h3 class="box-title">Personal Details</h3>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Sponsor</label>
                      <div class="col-sm-10">
                        <template v-if="model.sponsor">
                          <input
                            class="form-control"
                            type="text"
                            placeholder="Sponsored By"
                            v-model="model.sponsor.username"
                            disabled
                          />
                        </template>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Full Name</label>
                      <div class="col-sm-10">
                        <input
                          class="form-control"
                          type="text"
                          placeholder="Name and last name"
                          v-model="model.name"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label"
                        >Email Adress</label
                      >
                      <div class="col-sm-10">
                        <input
                          class="form-control"
                          type="email"
                          placeholder="example@example.com"
                          v-model="model.email"
                          readonly
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label"
                        >Phone Number</label
                      >
                      <div class="col-sm-10">
                        <input
                          class="form-control"
                          type="tel"
                          placeholder="123 456 7890"
                          v-model="model.phone"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="box box-solid bg-black">
              <div class="box-body">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">USDT Wallet ( TRC20 )</label>

                      <div class="col-sm-10 input-group">
                        <span class="input-group-addon">
                          <cryptoicon symbol="usdt" size="25" />
                        </span>

                        <input
                          v-model="model.token_wallet"
                          class="form-control"
                          type="text"
                          placeholder="Your USDT ( TRC20 ) Wallet"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="box box-solid bg-black">
              <div class="box-body">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Address</label>
                      <div class="col-sm-10">
                        <input
                          class="form-control"
                          type="text"
                          placeholder="A-458, Lorem Ipsum, city"
                          v-model="model.address"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">City</label>
                      <div class="col-sm-10">
                        <input
                          class="form-control"
                          type="text"
                          placeholder="Your City"
                          v-model="model.city"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Country</label>
                      <div class="col-sm-10">
                        <input
                          class="form-control"
                          type="text"
                          placeholder="Canada"
                          v-model="model.country"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="box box-solid bg-black">
              <div class="box-header with-border">
                <h3 class="box-title">Security</h3>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-12">
                    <email-auth-code
                      @code-changed="(evt) => (model.email_auth_code = evt)"
                    />

                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label"
                        >New Password</label
                      >
                      <div class="col-sm-10">
                        <input
                          class="form-control"
                          type="text"
                          v-model="model.password"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label"
                        >New Password Confirmation</label
                      >
                      <div class="col-sm-10">
                        <input
                          class="form-control"
                          type="text"
                          v-model="model.password_confirmation"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="ml-auto col-sm-10">
                        <button
                          :disabled="loading"
                          type="submit"
                          class="btn btn-success btn-block"
                        >
                          <template v-if="loading">
                            <i class="fa fa-spinner fa-spin"></i>
                            Loading
                          </template>
                          <template v-else>
                            Save Changes <i class="icon-pencil"></i>
                          </template>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { EmailAuthCode } from "@/components";
import SwapLeg from "@/components/SwapLeg";

export default {
  name: "user-profile",
  data() {
    return {
      loading: false,
      model: {
        username: "",
        email: "",
        name: "",
        last_name: "",
        address: "",
        city: "",
        country: "",
        zip: "",
        about: "",
        link: "",
        btc_wallet: "",
      },
    };
  },
  components: { EmailAuthCode, SwapLeg },
  created() {
    this.model = this.$store.getters.currentUser;
  },
  methods: {
    changePicture(env) {
      env.preventDefault();
      this.loading = true;
      let data = new FormData();
      data.append("file", this.$refs.picture.files[0]);

      this.$http({
        method: "put",
        url: "/api/v1/client/users/" + this.$store.getters.currentUser.uuid,
        data: data,
        headers: {
          "content-type": "application/json",
          Authorization: this.$store.getters.authToken,
        },
      })
        .then(() => {
          this.$store.dispatch("getUser");
          this.$toasted.show("Profile picture updated!", {
            position: "top-right",
            duration: 5000,
            type: "success",
            closeOnSwipe: true,
          });
          this.loading = false;
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true,
              });
            });
          this.loading = false;
        });
    },
    onCopy() {
      this.$toasted.show("Copied to clippboard!", {
        position: "top-right",
        duration: 5000,
        type: "success",
        closeOnSwipe: true,
      });
    },
    swapLeg(leg) {
      leg = leg === "left" ? false : true;
      this.loading = true;
      this.updateUser({ right: leg });
    },
    updateUser() {
      this.loading = true;
      this.$http({
        method: "put",
        url: "/api/v1/client/users/" + this.$store.getters.currentUser.uuid,
        data: this.model,
        headers: {
          "content-type": "application/json",
          Authorization: this.$store.getters.authToken,
        },
      })
        .then(() => {
          this.$store.dispatch("getUser");
          this.$toasted.show("Profile Updated!", {
            position: "top-right",
            duration: 5000,
            type: "success",
            closeOnSwipe: true,
          });
          this.loading = false;
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true,
              });
            });
          this.loading = false;
        });
    },
  },
};
</script>
